var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import authentication from "@irati/auth";
import brandingQuery, { brandingKey } from "./queries/branding";
import updateBrandingMutation, { updateBrandingKey } from "./mutations/brandingUpdate";
var BrandingService = /** @class */ (function (_super) {
    __extends(BrandingService, _super);
    function BrandingService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandingService.prototype.getBranding = function (variables, options) {
        return client.query(__assign(__assign({}, options), { query: brandingQuery, variables: variables })).then(function (res) { return res.data[brandingKey]; });
    };
    BrandingService.prototype.getForTeam = function (teamId, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            businessId: authentication.userTenant().uuid,
            teamId: teamId
        };
        return this.getBranding(variables, options);
    };
    BrandingService.prototype.get = function (options) {
        if (options === void 0) { options = {}; }
        var variables = {
            businessId: authentication.userTenant().uuid,
            userId: authentication.user().uuid
        };
        return this.getBranding(variables, options);
    };
    BrandingService.prototype.update = function (data, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            data: data
        };
        return client.mutate(__assign(__assign({}, options), { mutation: updateBrandingMutation, variables: variables })).then(function (res) { return res.data[updateBrandingKey]; });
    };
    return BrandingService;
}(PBService));
export default new BrandingService({ errorHandlers: [] });
